import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

export class RenderingProxy {
    async performance(range) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/back-office/renderings/performance?range=${range}`);
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }
}
